<template>
  <div class="enjoy-area mh-enjoy pb-100">
    <div class="container">
      <div class="row align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="100"
        >
          <div class="enjoy-img">
            <img src="@/assets/images/enjoy.png" alt="enjoy" />
          </div>
        </div>
        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="enjoy-content">
            <h2 class="text-white">استمتع بجميع الأفلام، البرامج التلفزيونية والمزيد</h2>
            <p>
              مع مجموعتنا الكبيرة والشاملة من القنوات التلفزيونية، لن تفوتك مبارياتك الرياضية المفضلة وبرامجك الترفيهية بعد الآن.
            </p>
            <h4 class="text-white">
              اشترك الآن في سيرفر loay iptv واحصل على دعم فني متميز طوال فترة اشتراكك.
            </h4>
            <div class="row align-items-center mb-30">
              <div class="col-lg-4 col-sm-6">
                <div class="starting-form mb-sm-0">
                  <span>الأسعار تبدأ من</span>
                  <h1>$ 9.99<sub>/ شهرياً</sub></h1>
                </div>
              </div>
              <div class="col-lg-8 col-sm-6">
                <div class="nestor-prepaid">
                  <span>تجربة قبل الاشتراك</span>
                  <h3 class="text-white">نوفر لك تجربة مجانية لتتأكد من الجودة والثبات بنفسك</h3>
                  <!-- نص مباشر بدون أي تشفير لطلب التجربة -->
                  <a href="https://wa.me/447429916178?text=مرحبا، أريد طلب تجربة مجانية لسيرفر loay iptv" target="_blank" class="read-more style-two">
                    اطلب تجربة الآن
                    <i class="ti ti-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
            <!-- نص مباشر بدون أي تشفير لعرض الأسعار -->
            <a href="https://wa.me/447429916178?text=مرحبا، أريد الاطلاع على خطط الأسعار والاشتراكات" target="_blank" class="btn bg-grey-teal">
              <span class="border-style">عرض جميع خطط الأسعار</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EnjoyTheAllMovies",
});
</script>